import { render, staticRenderFns } from "./courierDeliveryListNew.vue?vue&type=template&id=b89eeb76&scoped=true&"
import script from "./courierDeliveryListNew.vue?vue&type=script&lang=js&"
export * from "./courierDeliveryListNew.vue?vue&type=script&lang=js&"
import style0 from "./courierDeliveryListNew.vue?vue&type=style&index=0&id=b89eeb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89eeb76",
  null
  
)

component.options.__file = "courierDeliveryListNew.vue"
export default component.exports